import AccordionItemHandler from 'components/forms/new/AccordionItemHandler';
import WholesalerName from '../formFields/WholesalerName';
import CarriersMultiSelect from '../formFields/CarriersMultiSelect';
import RegionsMultiSelect from '../formFields/RegionsMultiSelect';
import LegalEntityName from 'pages/organisations/companies/v5/tabs/formFields/LegalEntityName';
import BusinessNumber from 'pages/organisations/companies/v5/tabs/formFields/BusinessNumber';

const WholesalerGeneralDetails = ({ errors, touched, darkMode }) => {
    const fields = [
        <WholesalerName
            key="wholesalerName"
            errors={errors}
            darkMode={darkMode}
            isAddMode={false}
        />,
        <LegalEntityName
            key="legalEntityName"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
        <BusinessNumber
            key="businessNumber"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
        <CarriersMultiSelect key="carriers" darkMode={darkMode} />,
        <RegionsMultiSelect key="regions" darkMode={darkMode} />,
    ];

    return (
        <AccordionItemHandler
            index={0}
            key="wholesalerGeneral"
            label="Wholesaler Details"
            errors={errors}
            touched={touched}
            defaultIsOpen={true}>
            {fields.filter(Boolean)}
        </AccordionItemHandler>
    );
};

export default WholesalerGeneralDetails;
